import { VisitFlowTypesModel } from '@w3lcome/types';
import { getNameField, getPrimaryKeyField } from '_/helpers/fields';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export function useUpdateVisitFlowTypes() {
  const { t } = useTranslation();

  const updateFieldsVisitFlowTypes = useCallback((data: VisitFlowTypesModel[]) => {
    const visitFlowTypesUpdated = data.reduce((acc: VisitFlowTypesModel[], e) => {
      const primaryKeyField = getPrimaryKeyField(e);
      const nameField = getNameField(e, t('Name'));

      const current = {
        ...e,
        fields: (e.fields || [])
          .concat([primaryKeyField, nameField] as any)
          .sort((a: any, b: any) => a.sort - b.sort),
      };

      return [...acc, current];
    }, []);

    return visitFlowTypesUpdated;
  }, []);

  return {
    updateFieldsVisitFlowTypes,
  };
}
